import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LogoutModal } from '@authentication/feature-login';
import { AuthorizeBeforeRedirectModule, DropdownModule } from '@inshared/shared/util-directives';
import { WucIconUiModule } from '@inshared/website-ui-components';
import { AutorisatieMenuComponent } from './autorisatie-menu.component';

@NgModule({
    imports: [CommonModule, LogoutModal, DropdownModule, WucIconUiModule, AuthorizeBeforeRedirectModule],
    declarations: [AutorisatieMenuComponent],
    exports: [AutorisatieMenuComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AutorisatieMenuModule {}
